export function MyXMLSerializer(s) {
  var out = "";

  var na = 0;
  if (s.attributes == null) out = s.data;
  else {
    out += "<" + s.nodeName;
    na = s.attributes.length;
    for (var n = 0; n < na; n++) {
      out += " " + s.attributes[n].name + "=" + "'" + s.attributes[n].value + "'";
    }

    if (s.hasChildNodes()) {
      out += ">\n";

      for (var n = 0; n < s.childNodes.length; n++) {
        out += MyXMLSerializer(s.childNodes[n]);
      }

      out += "</" + s.nodeName + ">" + "\n";
    } else out += " />\n";
  }

  return out;
}
